// extracted by mini-css-extract-plugin
module.exports = {"tags_wrapper":"news_tags_tags_wrapper__Vo8e2","tags_title":"news_tags_tags_title__b8Ogq","tags":"news_tags_tags__93HC2","tag_link":"news_tags_tag_link__P7UPq"};